export const Vacation = (props) => {
  const { size = 20, onClick, verticalAlign = '-4px', marginLeft, marginRight = '8px', top, color = '#726460', className = '' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg xmlns='http://www.w3.org/2000/svg' style={{ verticalAlign }} width={size} height={size} fill='none' viewBox='0 0 20 20'>
        <path
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
          d='M5 14.999a4.984 4.984 0 013.507-1.464m3.564 1.464a4.985 4.985 0 00-3.564-1.464m3.574-8.166c2.224.915 3.396 3.293 2.735 5.546l-.043.147c-.188.642-.913.978-1.546.717L6.53 9.023c-.633-.261-.887-1-.542-1.578l.08-.132c1.212-2.025 3.79-2.86 6.013-1.944zm0 0l.148.582a5.776 5.776 0 01-1.053 4.984m.905-5.566l-.534.3c-1.59.895-2.68 2.437-2.966 4.198m1.297.532l-1.37 3.136M6.247 2.496h7.507a3.748 3.748 0 013.748 3.748v7.51a3.748 3.748 0 01-3.748 3.748h-7.51a3.748 3.748 0 01-3.748-3.748V6.248a3.752 3.752 0 013.751-3.752z'
        ></path>
      </svg>
    </span>
  );
};
